import React, { FunctionComponent } from 'react';

import { formatDateTime } from '../../utils/formatDate';

export type FormattedDateProps = {
  value: string | Date;
};

export const FormattedDate: FunctionComponent<FormattedDateProps> = ({
  value,
}) => {
  const dateValue = typeof value === 'string' ? new Date(value) : value;
  return <>{formatDateTime(dateValue)}</>;
};
